'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


var _lodash = require('lodash');

var removeSensitiveInformation = function removeSensitiveInformation(normalisedError) {
    return _extends({}, normalisedError, {
        data: undefined,
        errorDetails: undefined
    });
};

var getResponseErrorData = function getResponseErrorData(data) {
    if (!data || !data.error) return undefined;
    var error = data.error;

    return {
        errorName: error.name,
        errorCode: error.code,
        errorMessage: error.message,
        errorDetails: error.details || error.detail
    };
};

var getResponseRequestData = function getResponseRequestData(request) {
    if (!request) return undefined;

    return {
        // Overwrite the other apiUrl as this is more detailed
        apiUrl: request.responseURL
    };
};

var getResponseData = function getResponseData(response) {
    if (!response) return undefined;

    return _extends({
        status: response.status,
        statusText: response.statusText
    }, getResponseRequestData(response.request), getResponseErrorData(response.data));
};

var getConfigData = function getConfigData(config) {
    if (!config) return undefined;

    return {
        apiUrl: config.url,
        method: config.method,
        data: config.data
    };
};

var normaliseError = function normaliseError(error) {
    return _extends({
        id: error.id,
        code: error.code
    }, getConfigData(error.config), getResponseData(error.response));
};

exports.default = function (_ref) {
    var error = _ref.error,
        sensitive = _ref.sensitive;

    var transformations = [normaliseError];
    if (sensitive) transformations.push(removeSensitiveInformation);
    return (0, _lodash.flow)(transformations)(error);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/processError.js
// module id = 1665
// module chunks = 0